import adds from "../adds/adds";
import display from "../dispay-listings-each/display";


const MainOneOnOverTheOther = document.getElementById("MainOneOnOverTheOther");

class StackDisplay {
  #initiated = false;
  #lastHtmlInStack;

  #isStackDispOpen = false




  #stackClosedWaiters = new Set();

  _waitUntilStackClosed() {
    // Already closed: return false immediately.
    if (!this.#isStackDispOpen) {
      return Promise.resolve(false);
    }

    // Open: wait until the final stack item closes.
    return new Promise((resolve) => {
      this.#stackClosedWaiters.add(resolve);
    });
  }

  #markStackClosed() {
    this.#isStackDispOpen = false;

    this.#stackClosedWaiters.forEach((resolve) => {
      resolve(false);
    });

    this.#stackClosedWaiters.clear();
  }





  _getOpenState() {
    return this.#isStackDispOpen
  }


  _display(html) {
    this.#isStackDispOpen = true

    adds._pauseVideoCarousel()
    if (this.#lastHtmlInStack === html) {
      console.log("same");
    }

    this.#lastHtmlInStack = html;

    MainOneOnOverTheOther.style.display = "flex";

    MainOneOnOverTheOther.insertAdjacentHTML(
      "beforeend",
      this._generateWraper(html)
    );
    if (!this.#initiated) {
      this._events();
      this.#initiated = true;
    }
  }

  _generateWraper(html) {
    return `
        <div class="MainOneOnOverTheOtherInner">${html}</div>
    `;
  }

  _initSwipe() {
    let gesture = null;

    const MIN_SWIPE_DISTANCE = 50;
    const MAX_SWIPE_TIME = 800;
    const LEFT_EDGE_MARGIN = 30;

    const getTopOverlay = () => {
      const overlays = MainOneOnOverTheOther.querySelectorAll(
        ".MainOneOnOverTheOtherInner"
      );

      return overlays[overlays.length - 1] || null;
    };

    const resetSwipePosition = async (element, distance) => {
      const animation = element.animate(
        [
          { translate: `${distance}px 0` },
          { translate: "0 0" },
        ],
        {
          duration: 220,
          easing: "cubic-bezier(0.22, 1, 0.36, 1)",
          fill: "forwards",
        }
      );

      try {
        await animation.finished;
      } catch { }

      animation.cancel();
      element.style.translate = "";
      element.style.willChange = "";
    };

    const touchStartHandler = (event) => {
      if (event.touches.length !== 1) return;

      const touch = event.touches[0];

      if (
        touch.pageX > LEFT_EDGE_MARGIN ||
        event.target.closest(".preventSwipeBack")
      ) {
        gesture = null;
        return;
      }

      const elementToRemove = getTopOverlay();
      if (!elementToRemove) return;

      const isLastChild = MainOneOnOverTheOther.childElementCount === 1;

      gesture = {
        startX: touch.pageX,
        startY: touch.pageY,
        startTime: Date.now(),
        distance: 0,
        blocked: false,
        elementToRemove,
        // Slide the parent for the last screen, avoiding a white flash.
        elementToMove: isLastChild
          ? MainOneOnOverTheOther
          : elementToRemove,
        isLastChild,
      };

      // Uses CSS translate, so any existing stack transform stays intact.
      gesture.elementToMove.style.willChange = "translate";
    };

    const touchMoveHandler = (event) => {
      if (!gesture || event.touches.length !== 1) return;

      const touch = event.touches[0];
      const deltaX = touch.pageX - gesture.startX;
      const deltaY = touch.pageY - gesture.startY;

      // Treat a primarily vertical movement as scrolling, not swipe-back.
      if (!gesture.blocked && Math.abs(deltaY) > Math.abs(deltaX)) {
        gesture.blocked = true;
        return;
      }

      if (gesture.blocked || deltaX <= 0) return;

      event.preventDefault();

      gesture.distance = Math.min(deltaX, window.innerWidth);
      gesture.elementToMove.style.translate = `${gesture.distance}px 0`;
    };

    const finishGesture = async () => {
      if (!gesture) return;

      const currentGesture = gesture;
      gesture = null;

      const duration = Date.now() - currentGesture.startTime;
      const overlayWidth =
        currentGesture.elementToMove.getBoundingClientRect().width;

      const isPastHalfway = currentGesture.distance >= overlayWidth / 2;

      const isValidSwipe =
        !currentGesture.blocked &&
        (
          isPastHalfway ||
          (
            currentGesture.distance >= MIN_SWIPE_DISTANCE &&
            duration <= MAX_SWIPE_TIME
          )
        );

      if (!isValidSwipe) {
        await resetSwipePosition(
          currentGesture.elementToMove,
          currentGesture.distance
        );
        return;
      }

      this._swipeAction(currentGesture);
    };

    document.addEventListener("touchstart", touchStartHandler, {
      passive: true,
    });

    document.addEventListener("touchmove", touchMoveHandler, {
      passive: false,
    });

    document.addEventListener("touchend", finishGesture, {
      passive: true,
    });

    document.addEventListener("touchcancel", finishGesture, {
      passive: true,
    });
  }


  async _swipeAction({
    elementToRemove,
    elementToMove,
    distance,
    isLastChild,
  }) {
    display._resetCurrentImageIndex();

    const rect = elementToMove.getBoundingClientRect();

    // Continue from the user's current drag position until fully off-screen.
    const finalDistance =
      distance + (window.innerWidth - rect.left) + 32;

    const exitAnimation = elementToMove.animate(
      [
        { translate: `${distance}px 0` },
        { translate: `${finalDistance}px 0` },
      ],
      {
        duration: 220,
        easing: "cubic-bezier(0.22, 1, 0.36, 1)",
        fill: "forwards",
      }
    );

    try {
      await exitAnimation.finished;
    } catch { }

    elementToRemove.remove();

    if (isLastChild) {
      MainOneOnOverTheOther.style.display = "none";
      // this.#isStackDispOpen = false;
      this.#markStackClosed();
      adds._openVideoAgain();
    }

    exitAnimation.cancel();
    elementToMove.style.translate = "";
    elementToMove.style.willChange = "";
  }

  async _goBackOnStack(e, el) {
    console.log('here');
    display._resetCurrentImageIndex();

    const sourceEl = e?.target || el;
    if (!sourceEl) return;

    const elementToRemove = sourceEl.closest(".MainOneOnOverTheOtherInner");
    if (!elementToRemove || elementToRemove.dataset.isClosing) return;

    elementToRemove.dataset.isClosing = "true";

    const isLastChild = MainOneOnOverTheOther.childElementCount === 1;


    // When closing the last overlay, move its parent too.
    const elementToAnimate = isLastChild
      ? MainOneOnOverTheOther
      : elementToRemove;

    const rect = elementToAnimate.getBoundingClientRect();
    const distanceToRight = window.innerWidth - rect.left + 32;

    let exitAnimation;

    try {
      exitAnimation = elementToAnimate.animate(
        [
          { transform: "translateX(0)" },
          { transform: `translateX(${distanceToRight}px)` },
        ],
        {
          duration: 680,
          easing: "cubic-bezier(0.22, 1, 0.36, 1)",
          fill: "forwards",
        }
      );

      await exitAnimation.finished;
    } catch {
      // Still close if the animation is interrupted.
    }

    elementToRemove.remove();

    // Check the real state now, after removal.
    const stackIsEmpty = MainOneOnOverTheOther.childElementCount === 0;

    if (stackIsEmpty) {
      console.log("last child removed");

      MainOneOnOverTheOther.style.display = "none";
      // this.#isStackDispOpen = false;
      this.#markStackClosed();

      exitAnimation?.cancel();
    }
  }


  _events() {
    this._initSwipe();

    MainOneOnOverTheOther.addEventListener("click", (e) => {
      const closestCloseButtonCheck = e.target.closest(
        ".CloseCurrentStackPageButton"
      );

      if (closestCloseButtonCheck) {
        this._goBackOnStack(e)
      }
    });
  }
}

export default new StackDisplay();
